import React from "react";
import { FontIcon, IconButton, mergeStyleSets, Modal, Text, useTheme } from "@fluentui/react";
import { replaceImgTagsWithWarningMessage } from "../helpers/snippetHelpers";

const getClassNames = (theme) =>
  mergeStyleSets({
    root: {
      display: "flex",
      flexDirection: "column",
      padding: theme.spacing.s1,
      width: `calc(100% - ${theme.spacing.m})`,
      height: "80%",
    },
    header: {
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    headerTitle: {
      color: theme.palette.themePrimary,
      marginLeft: theme.spacing.s1,
      fontWeight: "bold",
      marginBottom: theme.spacing.s1,
    },
    content: {
      padding: theme.spacing.s1,
      margin: theme.spacing.s1,
      border: `1.5px solid ${theme.palette.borderLight}`,
      minHeight: "80%",
      overflowX: "auto",
    },
  });

const PreviewSnippetModal = ({ snippet, isOpen, onClose }) => {
  const theme = useTheme();
  const { root, header, headerTitle, content } = getClassNames(theme);

  return (
    <Modal
      titleAriaId={snippet?.key}
      isOpen={isOpen}
      onDismiss={() => onClose(false)}
      isBlocking={false}
      containerClassName={root}
    >
      <div className={header}>
        <Text className={headerTitle} variant="mediumPlus">
          {snippet?.text}
        </Text>
        <IconButton ariaLabel="Close modal" onClick={() => onClose(false)}>
          <FontIcon iconName="Cancel" />
        </IconButton>
      </div>

      {snippet?.content && (
        <div
          className={content}
          dangerouslySetInnerHTML={{ __html: replaceImgTagsWithWarningMessage(snippet?.content) }}
        />
      )}
    </Modal>
  );
};

export default PreviewSnippetModal;
